import { MaybeOptimisticChatTextMessage } from "@lazarentertainment/public-chat-web"
import {
  ChatMessage,
  ChatName,
  ChatText,
} from "client/designSystem/ChatMessage"

import { ChatView } from "../../constants"
import { ChatMessageWrapper } from "../ChatMessageStyles"

export const ChatMessageBubble = ({
  message,
  view,
}: {
  message: MaybeOptimisticChatTextMessage
  view: ChatView
}) => (
  <ChatMessageWrapper
    $isMe={message.isMe}
    data-view={view}
    data-pull-right={message.isMe && view !== ChatView.OVERLAY}
  >
    <ChatMessage
      variant={view === ChatView.OVERLAY ? "overlay-primary" : "text"}
    >
      <ChatName colon verifiedIcon={message.isChannelOwner}>
        {message.isMe
          ? `${message.displayName} (you)`
          : message.displayName}
      </ChatName>
      <ChatText text={message.text} linkify={message.isChannelOwner} />
    </ChatMessage>
  </ChatMessageWrapper>
)
